import { DEFAULT_AGENT } from '../../controllers/agents/constants';

import { type AgentSelectionCandidate } from './AgentSelectionCandidate';

export const isDefaultAgentSelection = (agent: AgentSelectionCandidate | undefined): boolean =>
	!agent ||
	agent.is_default === true ||
	agent.id === DEFAULT_AGENT.id ||
	agent.named_id === DEFAULT_AGENT.named_id;
